import React, { useEffect } from 'react';
import { OpeningSection } from '../components/page/sections/OpeningSection';
import { ChallengeSection } from '../components/page/sections/ChallengeSection';
import { JourneySection } from '../components/page/sections/JourneySection';
import { WebsiteSection } from '../components/page/sections/WebsiteSection';
import { ChannelsSection } from '../components/page/sections/ChannelsSection';
import { UseCasesSection } from '../components/page/sections/UseCasesSection';
import { SignalsSection } from '../components/page/sections/SignalsSection';
import { CompoundSection } from '../components/page/sections/CompoundSection';
import { StationSection } from '../components/page/sections/StationSection';
import { CampaignSection } from '../components/page/sections/CampaignSection';
import { CongressSection } from '../components/page/sections/CongressSection';
import { PageNav } from '../components/page/PageNav';
import { CongressShortcut } from '../components/page/CongressShortcut';
import { useActiveSection } from '../hooks/useActiveSection';
import { deckPages } from '../data/deck';

/** REKOVELLE × Snakker — from attention to action, as one scrolling page. */
export function Presentation() {
  const active = useActiveSection(deckPages.map(page => page.id));

  // Honour deep links like /#signals once the sections have rendered.
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return;
    const timer = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({
        block: 'start'
      });
    }, 80);
    return () => window.clearTimeout(timer);
  }, []);
  return <div className="w-full bg-[var(--surface)]" data-id="element-904" data-mp="1k5cokg5zmz8m">
      <OpeningSection data-id="element-905" data-mp="1k2i3qnj2bceo" />
      <CongressSection data-id="element-906" data-mp="1p3xrincmjx0r" />
      <ChallengeSection data-id="element-907" data-mp="1p236l91cs4wo" />
      <JourneySection data-id="element-908" data-mp="1p2mnqnj6ip9n" />
      <WebsiteSection data-id="element-909" data-mp="3lvo7i5pej086" />
      <ChannelsSection data-id="element-910" data-mp="3lw7nvhzelgk3" />
      <UseCasesSection data-id="element-911" data-mp="3lwzleyck9od0" />
      <SignalsSection data-id="element-912" data-mp="3lxivxtzvtah0" />
      <CompoundSection data-id="element-913" data-mp="3qurevwsutijb" />
      <StationSection data-id="element-914" data-mp="3qtzgke7vh6pc" />
      <CampaignSection data-id="element-915" data-mp="3qvkdgahnt1qd" />
      <PageNav active={active} data-id="element-916" data-mp="3qwvei2jpzvds" />
      <CongressShortcut hidden={active === 'congress'} data-id="element-917" data-mp="3ittfvpsurb9l" />
    </div>;
}